import { CHARACTERS } from "@/constants/vue-events";
import _debounce from "lodash.debounce";

export const KeyboardBindingMixin = {
  methods: {
    _keyListener(e) {
      const deniedTags = ["textarea", "text", "number"];
      if (!CHARACTERS.includes(e.key) || deniedTags.includes(e.target.type))
        return;
      let answer = this.answers.find((answer) => answer.key === e.key);
      if (!answer) return;
      this.onChange(answer.code);
    },
  },
  computed: {
    answers() {
      if (this.question.answers.length > CHARACTERS.length)
        return this.question.answers;
      return this.question.answers.map((answer, index) => {
        return { ...answer, key: CHARACTERS[index] };
      });
    },
  },
  mounted() {
    window.addEventListener("keypress", this._keyListener);
  },
  beforeDestroy() {
    window.removeEventListener("keypress", this._keyListener);
  },
};

export const EnterSubmitMixin = {
  methods: {
    enterListener: _debounce(async function(e) {
      if (e.shiftKey === true) return false;
      if (e.which === 13) {
        if (!this.loading) {
          await this.onSubmit();
          return false;
        }
      }
    }, 100),
  },
  mounted() {
    window.addEventListener("keypress", this.enterListener);
  },
  beforeDestroy() {
    window.removeEventListener("keypress", this.enterListener);
  },
};
